import { axiosService } from "@/services/AxiosService";


/**
 * @typedef {Object} HorseTreatment
 * @property {number} id - ID del record del trattamento
 * @property {number} horse_id - ID del cavallo associato
 * @property {number} treatment_id - ID del trattamento associato
 * @property {Date} date - Data del trattamento
 * @property {Date} expiration - Data di scadenza del trattamento
 * @property {string} created - Data di creazione del record
 * @property {string} modified - Data di modifica del record
 * @property {string} note - Note aggiuntive sul trattamento
 * @property {boolean} done - Stato del trattamento (completato o meno)
 */

/**
 * @typedef {Object} Treatment
 * @property {number} id - ID del record del trattamento
 * @property {string} type - Tipo di trattamento
 */

/**
 * Servizio per gestire le informazioni dei cavalli.
 */
class HorsesTreatmentService {

    abortController = null;

    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    


    /**
     * 
     * @returns {Promise<HorseTreatment[]>} - 
     * @throws {Error} - 
     */
    async getHorseTreatments(page, search = '', params = {}, length = 10) {
        try {
            const response = await this.axiosInstance.post('/horse-treatments/get-treatments-given-horse-id', {page, length, search, ...params});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse treatments info');
            }

            /** @type {HorseTreatment[]} */
            return response.data;
        } catch (error) {
            console.error('Error fetching horse treatments info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<HorseTreatment>} - 
     * @throws {Error} - 
     */
    async getHorseTreatmentById(id) {
        try {
            const response = await this.axiosInstance.post('/horse-treatments/get-horse-treatment-given-id', {horse_treatment_id: id});

            if (response.status !== 200) {
                throw new Error('Failed to fetch horse treatments info');
            }

            /** @type {HorseTreatment} */
            return response.data.data;
        } catch (error) {
            console.error('Error fetching horse treatments info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }


    /**
     * 
     * @returns {Promise<HorseTreatment>} 
     * @throws {Error} 
     */
    async saveHorseTreatment(data) {
        try {
            const formData = new FormData();

            // Separate File objects from horse_images and keep only those with id
            const files = [];
            const imagesWithId = data.horse_treatment_images.filter(image => {
                if (image.url instanceof File) {
                    files.push(image.url);
                    image.url = null;
                    return false; // Exclude this item from horse_images
                }
                return true; // Keep this item in horse_images
            });

            console.log(imagesWithId);

            // Append all fields in data to FormData individually
            for (const key in data) {
                if (key === 'horse_treatment_images') {
                // Append the modified horse_images to FormData as a JSON string
                formData.append('horse_treatment_images', JSON.stringify(data.horse_treatment_images));
                } else {
                // Append other fields as they are
                formData.append(key, data[key]);
                }
            }

            // Append each File object to FormData under the 'files' field
            files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });
            const response = await this.axiosInstance.post('/horse-treatments/save-horse-treatment', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });

            if (response.status !== 200) {
                throw new Error('Failed to save horse treatments data');
            }

            /** @type {HorseTreatment} */
            return response.data.data.result;
        } catch (error) {
            console.error('Error saving horse treatments:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    /**
     * 
     * @returns {Promise<Treatment[]>}
     * @throws {Error}
     */
    async getTreatments() {
        try {
            const response = await this.axiosInstance.post('/horse-treatments/get-treatments');

            if (response.status !== 200) {
                throw new Error('Failed to fetch treatments info');
            }

            /** @type {Treatment[]} */
            return response.data.data.treatments;
        } catch (error) {
            console.error('Error fetching treatments info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

    
}

export const horsesTreatmentService = new HorsesTreatmentService();
